import React, {Component} from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {Link, browserHistory} from 'react-router'
import {
    Page,
    CustomerServiceQrcode,
} from '../components'
import '../styles/question/QuestionPage.css'
import defaultImg from '../images/no-source.png'
import glImg from '../images/gonglve.jpg'

import {
    SearchBar,
    Cell,
    CellBody,
    CellFooter,
    Flex,
    FlexItem,
    CellsTitle,
    LoadMore,
} from 'react-weui';
import config from '../config'


class QuestionPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialized: false,
            results: [],
            keywords: '',
        };
        this.handleQuestionSearch = this.handleQuestionSearch.bind(this);
        this.handleQuestionSearchSubmit = this.handleQuestionSearchSubmit.bind(this);
        this.handleContactCustomer = this.handleContactCustomer.bind(this);
        this.handleCancelQuestionSearch = this.handleCancelQuestionSearch.bind(this);
    }

    handleQuestionSearch(text) {
        this.setState({
            keywords: text,
        })
    }

    componentDidMount() {
        axios.get(`/api/qa/tutorial/index`).then((response) => {
            const {items} = response.data.data
            if (response.data.code === 0) {
                this.setState({
                    results: items,
                    initialized: true,
                });
            }
        });
        this.props.dispatch({
            type: 'CUSTOMER_QRCODE_INIT',
            payload: {
                api: '/api/board/service/allocate',
                title: '长按二维码联系客服',
            }
        })

        // init sharedata
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: '十方教育最全功能介绍',
                desc: '你想要的答案都在这里',
                imgUrl: glImg,
                type: 'link',
                link: window.location.href,
            }
        });
    }

    handleCancelQuestionSearch() {
        axios.get(`/api/qa/tutorial/index`).then((response) => {
            const {items} = response.data.data
            if (response.data.code === 0) {
                this.setState({
                    results: items,
                });
            }
        });
        this.props.dispatch({
            type: 'CUSTOMER_QRCODE_INIT',
            payload: {
                api: '/api/board/service/allocate',
                title: '长按二维码联系客服',
            }
        })
    }

    handleQuestionSearchSubmit() {
        const {keywords} = this.state;
        const ts = Date.now();
        axios.get(`/api/qa/tutorial/index?ts=${ts}&keyword=${keywords}`).then((response) => {
            const {items} = response.data.data
            if (response.data.code === 0) {
                this.setState({
                    results: items,
                });
            }
        });
    }

    handleContactCustomer() {
        window.location.href = '/activity/servicepage/'
    }

    render() {
        const {initialized} = this.state;
        if (!initialized) {
            return (
                <Page>
                    <div className="question-page-div">
                        <LoadMore loading />
                    </div>
                </Page>
            )
        }

        return (
            <Page>
                {this.props.customerservice.QrcodeShow &&
                <CustomerServiceQrcode/>
                }
                <div className="question-page-div">
                    <SearchBar className="content-center"
                               onSubmit={this.handleQuestionSearchSubmit}
                               onCancel={this.handleCancelQuestionSearch}
                               onChange={this.handleQuestionSearch}
                               placeholder="输入关键词搜索"
                               lang={{
                                   cancel: '取消',
                               }}
                    />
                    <div>
                        <div className="question-max-height">
                            <CellsTitle className="question-title">热点问题</CellsTitle>
                            <div className="question-font_16 question-content">
                                {
                                    this.state.results.length > 0 ?
                                        this.state.results.map((item, i) => {
                                            return (
                                                <Cell key={item.id} href={item.url} access>
                                                    <CellBody className='text-overflow-content'>
                                                        <p className="text-overflow">{item.title}</p>
                                                    </CellBody>
                                                    <CellFooter/>
                                                </Cell>
                                            )
                                        })
                                        :
                                        <div className="no-source-content">
                                            <img src={defaultImg} alt="没有内容"/>
                                            <p>sorry没有找到</p>
                                        </div>
                                }
                            </div>
                            <p className="text-center text-minor margin-top">讲师管理后台：{config.ADMIN_BASE_URL}</p>
                        </div>
                        <Flex className="question-bottom-nav wk-border-line-before g-position-rlt">
                            <FlexItem className="question-bottom-item">
                                <Link to={"/question/category"}>
                                    <i className="iconfont icon-caidan question-icon"></i>
                                    <div className="question-icon-font">全部问题</div>
                                </Link>
                            </FlexItem>
                            <FlexItem className="question-bottom-item">
                                <Link to={`/complain/0/0`}>
                                    <i className="iconfont icon-yijianfankui question-icon"></i>
                                    <div className="question-icon-font">投诉反馈</div>
                                </Link>
                            </FlexItem>
                            <FlexItem className="question-bottom-item" onClick={this.handleContactCustomer}>
                                <i className="iconfont icon-pinglun2 question-icon"></i>
                                <div className="question-icon-font">联系客服</div>
                            </FlexItem>
                        </Flex>
                    </div>
                </div>
            </Page>
        );
    }
}


export default connect((state) => ({
    customerservice: state.customerservice,
}))(QuestionPage)



// WEBPACK FOOTER //
// ./src/pages/QuestionPage.js